import * as React from 'react';
import { Control } from 'react-redux-form';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {isArrayEmpty, isFormEmpty} from '../../utils/generalUtils';
import {BasePage} from '../reusableComponents/BasePage';
import {Form} from '../reusableComponents/FormComponents/Form';
import {FormFooter} from '../reusableComponents/FormComponents/FormFooter';
import {InputField} from '../reusableComponents/FormComponents/InputField';
import {FileInputComponent} from './FileInputComponent';
import './modules.scss';
import {QuestionsTable} from './QuestionsTable';
import {InstructionsTable} from './InstructionsTable';
import {saveModules} from '../../services/moduleService';

import { FILESALLOWEDEXTENSION, FILESALLOWEDEXE } from 'src/constants/generals';
import {getCategoryDetails} from '../../services/moduleService';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {Loader} from '../reusableComponents/Loader/Loader';
import {Async} from '../reusableComponents/Async';
import * as console from 'console';
import { getUserData } from 'src/services/utilityServices';

export interface ICreateModuleProps {
    history: IHistory;
    accessLevel: string;
    moduleType?: string;
}
export interface IUserFormState {
    isL3User: boolean;
}
export class CreateModuleImpl extends React.Component<ICreateModuleProps, { selectedLevel: string[], categoryList: [], subCategoryList: string[], subCategoryOpt : string[]}> {
    constructor(props: ICreateModuleProps) {
        super(props);
        this.state = {selectedLevel: [], categoryList: [], subCategoryList: [],subCategoryOpt : []};
    }

    public promise = async () => {
        const CategoryArr = await getCategoryDetails();
        this.setState({categoryList: CategoryArr[0]});
        this.setState({subCategoryList: CategoryArr[1]});
    }

    public refs: {
        links: FileInputComponent;
        questions: QuestionsTable;
        instructionsTable: InstructionsTable;
    };
    public categoryOptions = () => {
        let UserData = getUserData().category;
        let categoryOptions = [];
        for ( let i = 0; i < this.state.categoryList.length; i++ ) {
            let arr = this.state.categoryList[i];
            if(UserData == arr[0] || UserData === 'all') {
                categoryOptions.push({label: arr[1], value: arr[0]});
            }
       }
        return categoryOptions;
    }
    // public categoryOptions = () => {
    //     let UserData = getUserData().category;
    //     // UserData = '1';
    //     let idStr = '';
    //     let categoryOptions = [];
    //     for ( let i = 0; i < this.state.categoryList.length; i++ ) {
    //         let arr = this.state.categoryList[i];
    //         if(UserData == arr[0] || UserData === 'all') {
    //             idStr = arr[0];
    //             idStr = idStr.toString();
    //             categoryOptions.push({label: arr[1], value: idStr});
    //         }
    //    }
    //    return categoryOptions;
    // }

    // public subcategoryOptions = () => { 
    //     let subcategoryOptions = [];
    //     let subCategoryOptList = [];
    //     const selCategoryOptions = this.state.selectedLevel;
    //     subCategoryOptList = this.state.subCategoryList; 
    //     let CategoryID = selCategoryOptions;
    //     alert('Category '+selCategoryOptions);
    //     let key = Number[0];
    //     for ( let j = 0; j < subCategoryOptList.length; j++ ) {
    //         let arr = subCategoryOptList[j];
    //         alert('Sub '+arr);
    //         let ObjKeys = Object.keys(subCategoryOptList[j]);
    //         if ( ObjKeys == CategoryID ) {
    //             key = CategoryID;
    //             let newArr = arr[key];
    //             for ( let k = 0; k < newArr.length; k++ ) {
    //                 let subCatOpt = newArr[k];
    //                 subcategoryOptions.push({label: subCatOpt[1], value: subCatOpt[0]});
    //             }
    //         }
    //     }
    //     this.setState({
    //         subCategoryOpt: subcategoryOptions
    //     });
    //     return subcategoryOptions;                   
    // }


    // public onCategoryChange = async (value) => {
    //     if (value) {
    //         await this.setState({
    //             selectedLevel: value
    //         });
    //         const category = this.state.selectedLevel;
    //         alert('sel '+value);
    //             let newarr = this.subcategoryOptions();
    //     }
    // }
    public subcategoryOptions = (SubCategory) => {
        let subcategoryOptions = [];
        let subCategoryOptList = [];
        // const selCategoryOptions = this.state.selectedLevel;
        // alert(selCategoryOptions);
        subCategoryOptList = this.state.subCategoryList;
        let idStr = ''; 
        let key = Number[0];
        // let CategoryID = selCategoryOptions;
        let CategoryID = SubCategory;
        for ( let j = 0; j < subCategoryOptList.length; j++ ) {
            let arr = subCategoryOptList[j];
            let ObjKeys = Object.keys(subCategoryOptList[j]);
            if ( ObjKeys == CategoryID ) {
                key = CategoryID;
                let newArr = arr[key];
                for ( let k = 0; k < newArr.length; k++ ) {
                    let subCatOpt = newArr[k];
                    idStr = subCatOpt[0];
                    idStr = idStr.toString();    
                    subcategoryOptions.push({label: subCatOpt[1], value: idStr});
                }
            }
        }
        this.setState({
            subCategoryOpt: subcategoryOptions
        });
        return subcategoryOptions;                   
    }

    public onCategoryChange = async (value) => {
        if (value) {
            await this.setState({
                selectedLevel: value
            });
            const category = this.state.selectedLevel;
            let newarr = this.subcategoryOptions(category);
        }
    }
    public handleSubmit = async (values) => {
        const isInstruction = this.props.moduleType === 'Instruction Module';
        let ignoreList = ['Instructions', 'subcategory'];
        if (isInstruction) {
            ignoreList.push('moduleMinMarkToPass');
        }

        if (isFormEmpty(values, ignoreList)) {
            return;
        }

        if (!this.refs.links.fileAndURLs.urls.length && !this.refs.links.fileAndURLs.files.length) {
            isArrayEmpty([], 'Please add File(s)/URL(s)');
            return;
        }

        let questions = [];
        let instructionsString = "";
        
        if (!isInstruction) {
            if (!this.refs.questions || isArrayEmpty(this.refs.questions.questions, 'Please add at-least one question set')) {
                return;
            }
            questions = this.refs.questions.questions;
        } else {
            const instTable = this.refs.instructionsTable as any;
            if (!instTable || instTable.state.instructions.length === 0) {
                isArrayEmpty([], 'Please add at-least one instruction');
                return;
            }
            // Send the raw array to the backend, it will be stored row by row
            const instArray = instTable.state.instructions;
            instructionsString = JSON.stringify(instArray);
        }

        const finalModuleType = values.moduleType || 'Training Module';
        return await saveModules(
            values.moduleName, values.moduleDesc, 
            isInstruction ? "0" : values.moduleMinMarkToPass, 
            values.category, values.subcategory, values.TrainingDuration, 
            this.refs.links.fileAndURLs.files, this.refs.links.fileAndURLs.urls, 
            questions, this.props.history, finalModuleType, instructionsString
        );
    }
    public renderContent = () => {
            const isInstruction = this.props.moduleType === 'Instruction Module';
            return <Form model="forms.moduleForm" onSubmit={this.handleSubmit} className="module-form">
            <InputField
                id="moduleType"
                hintText=""
                color={'white'}
                label="Module Type:"
                type="select"
                required
                model=".moduleType"
                noChips={true}
                menuItems={[
                    {label: "Training Module", value: "Training Module"},
                    {label: "Instruction Module", value: "Instruction Module"}
                ]}
                defaultValue="Training Module"
            />
            <InputField
                id="moduleName"
                hintText=""
                label="Training Module Name:"
                type="text"
                required
                model=".moduleName"
            />
            <InputField
                id="moduleDesc"
                hintText=""
                color="white"
                label="Training Module Description:"
                type="textarea"
                required
                model=".moduleDesc"
            />
            {!isInstruction && (
                <InputField
                    id="moduleMinMarkToPass"
                    hintText=""
                    label="Minimum marks to pass:"
                    minValue={1}
                    maxValue={100}
                    type="number"
                    required
                    model=".moduleMinMarkToPass"
                />
            )}
            <InputField
                id="modulePeriod"
                hintText=""
                minValue={0}
                maxValue={30}
                label="Training Period (In Days) :"
                type="number"
                required
                model=".TrainingDuration"
            />
            <InputField
                id="category"
                hintText=""
                color={'white'}
                label="Category:"
                required
                type="select"
                model=".category"
                noChips={true}
                onChange={this.onCategoryChange}
                menuItems={this.categoryOptions()}
            />
            <InputField
                id="subcategory"
                hintText=""
                color={'white'}
                label="Sub Category:"
                required
                type="select"
                model=".subcategory"
                noChips={true}
                menuItems={this.state.subCategoryOpt ? this.state.subCategoryOpt : this.subcategoryOptions('')}
            />
            
            <FileInputComponent AcceptFileType={FILESALLOWEDEXE} Extensions={FILESALLOWEDEXTENSION} ref="links"/>
            {!isInstruction && <QuestionsTable ref="questions"/>}
            {isInstruction && <InstructionsTable ref="instructionsTable" />}
            <FormFooter submitLabel="Create Module"/>
        </Form>;
    }

    public render() {
        return <BasePage title="Create Training Module" icon="chalkboard-teacher">
             <Async
                identifier="ModuleUpdateForm"
                promise={this.promise}
                content={this.renderContent()}
                loader={<Loader type="async"/>}
                error={<ErrorPage/>}
            />
            
        </BasePage>;
    }
}

export function mapStateToProps(state: any) {
    return {
        moduleType: state.forms && state.forms.moduleForm ? state.forms.moduleForm.moduleType : 'Training Module'
    };
}

export const CreateModule = withRouter(connect<{}, {}, ICreateModuleProps>(mapStateToProps)(CreateModuleImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modules/CreateModule.tsx